import axios from "axios";

export const api = axios.create({
  baseURL: "https://ser.overall.cloud:3333",
  //baseURL: "http://localhost:3333",
});

export default api;
